<script lang="ts">
    import { onMount } from 'svelte'
    import type { FormDataLastEmissionDto } from '../../modules/toolsApi/forms/form-datas/dto/form-data-last-emission.dto'
    import { GridBadge, GridBadgeClassEnum, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'

    export let lastEmissions: FormDataLastEmissionDto[] = null
    let pending = lastEmissions.filter((el) => !el.emited || el.status < 100)

    function getStatusLabel(status: number) {
        if (status === 60) return 'Rascunho'
        if (status === 110) return 'Assinado'
        return 'Completo'
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.showHeaders = false
        grid.showActs = false
        grid.showFilter = false
        grid.cols.push(new GridCol({ content: 'Documento', size: 10 }))
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        // grid lines
        for (const item of pending) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.title })
            line.slots.push({
                content: new GridBadge({
                    class: GridBadgeClassEnum.badge_alert,
                    label: getStatusLabel(item.status),
                }),
            })
            grid.lines.push(line)
        }
        grid = grid
    }

    onMount(() => {
        loadGrid()
    })
</script>

<div class="root">
    <div class="grid-form">
        <div class="config-box m-3 pending">
            <div class="alert alert-warning pending_warning text-center">
                {#if pending.length <= 1}
                    Atenção: Um documento obrigatório ainda não foi emitido ou assinado.<br />
                    Emita o documento antes de realizar o agendamento.
                {:else}
                    Atenção: Documentos obrigatórios ainda não foram emitidos ou assinados.<br />
                    Emita os documentos antes de realizar o agendamento.
                {/if}
            </div>
            <Zgrid {grid}></Zgrid>
        </div>
    </div>
</div>

<style>
</style>
